import { blackMain, headerHeight } from '../../theme';

const styles = () => ({
  root: {
    width: '100%',
    height: headerHeight,
    display: 'flex',
    alignItems: 'center',
    backgroundColor: blackMain,
  },
  navBarHidden: {
    marginRight: 'auto',
    '@media (min-width:940px)': {
      display: 'flex',
    },
    '@media (max-width:940px)': {
      display: 'none',
    },
  },
  drawerHidden: {
    '@media (min-width:940px)': {
      display: 'none',
    },
    '@media (max-width:940px)': {
      display: 'block',
    },
  },
});

export default styles;
